// https://docs.sentry.io/clients/javascript/tips/#decluttering-sentry
export const IGNORE_ERRORS = [
  // Random plugins/extensions
  /top\.GLOBALS/,
  // See: http://blog.errorception.com/2012/03/tale-of-unfindable-js-error.html
  /originalCreateNotification/,
  /canvas.contentDocument/,
  /MyApp_RemoveAllHighlights/,
  /http:\/\/tt\.epicplay\.com/,
  /Can't find variable: ZiteReader/,
  /jigsaw is not defined/,
  /ComboSearch is not defined/,
  /http:\/\/loading\.retry\.widdit\.com/,
  /atomicFindClose/,
  // Facebook borked
  /fb_xd_fragment/,
  // Tiktok
  /i18n\/pixel\/events/,
  // ISP "optimizing" proxy - `Cache-Control: no-transform` seems to
  // reduce this. (thanks @acdha)
  // See http://stackoverflow.com/questions/4113268
  /bmi_SafeAddOnload/,
  /EBCallBackMessageReceived/,
  // See http://toolbar.conduit.com/Developer/HtmlAndGadget/Methods/JSInjection.aspx
  /conduitPage/,
  // Google Translate
  /__gg__\.translateNotifyApiReady/,
  // others
  /function Error\(\) \{ \[native code\] \}/,
  /require is not defined/,
  // Network Errors
  /Network request failed/,
  /Failed to fetch/,
  /NetworkError/,
  /TypeError: Failed to fetch/,
  /TypeError: NetworkError when attempting to fetch resource./,
  /TypeError: Cancelled/,
  /TypeError: cancelado/,
  /^No error$/,
  /__show__deepen/,
  /Access is denied/,
  /anonymous function: captureException/,
  /Blocked a frame with origin/,
  /console is not defined/,
  /Error: AccessDeny/,
  /event is not defined/,
  /ibFindAllVideos/,
  /SecurityError/,
  /win\.document\.body/,
  /window\._sharedData\.entry_data/,
];

export const IGNORE_URLS = [
  // Facebook flakiness
  /graph\.facebook\.com/i,
  // Facebook blocked
  /connect\.facebook\.net\/en_US\/all\.js/i,
  // Tiktok blocked
  /analytics\.tiktok\.com\/i18n\/pixel\/identify\.js/i,
  // Chrome extensions
  /extensions\//i,
  /extension\//i,
  /^chrome:\/\//i,
  /^moz-extension:\/\//i,
];
